import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import { useRoute, useRouter } from 'vue-router/composables';
import CustomSettingsModal from '@/views/components/cookies/CustomSettingsModal.vue';
import AppConfig from '@/configLoader';
import { bootstrap, optIn } from 'vue-gtag';
import { CookieClaimManager, CookieClaimOptions } from '@/services/CookieClaimManager';
//firebase
import { initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CookiesBar',
    setup(__props) {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const cookieClaimManager = new CookieClaimManager();
        const currentClaims = ref(cookieClaimManager.readGivenClaim());
        const isCustomSettingsVisible = ref(false);
        const hasAnalyticsAllowedInConfig = computed(() => AppConfig.getConfig().google_analytics.allowed == true);
        const hasFirebaseAllowed = computed(() => AppConfig.getConfig().firebase.allowed == true);
        const firebaseConfiguration = computed(() => AppConfig.getConfig().firebase.config);
        function openPolicy() {
            router
                .push({
                name: 'privacyPolicy',
                params: { lang: route.params.lang }
            })
                .catch((err) => err);
        }
        function acceptCookies() {
            cookieClaimManager
                .addLocalClaim(CookieClaimOptions.ACCEPT_ESSENTIAL_COOKIES)
                .addLocalClaim(CookieClaimOptions.ACCEPT_ANALYTICS_COOKIES)
                .commit();
            if (hasAnalyticsAllowedInConfig.value == true) {
                enablePlugin();
                // Initialize Firebase
            }
            if (hasFirebaseAllowed.value) {
                // Initialize Firebase
                const app = initializeApp(firebaseConfiguration.value);
                // Initialize Performance Monitoring and get a reference to the service
                getPerformance(app);
            }
            currentClaims.value = cookieClaimManager.readGivenClaim();
        }
        function rejectCookies() {
            cookieClaimManager.addLocalClaim(CookieClaimOptions.ACCEPT_ESSENTIAL_COOKIES).commit();
            currentClaims.value = cookieClaimManager.readGivenClaim();
        }
        function openCustomSettings() {
            isCustomSettingsVisible.value = true;
        }
        function closeCustomSettingsModal() {
            isCustomSettingsVisible.value = false;
            currentClaims.value = cookieClaimManager.readGivenClaim();
        }
        function enablePlugin() {
            bootstrap().then(() => {
                optIn();
            });
        }
        return { __sfc: true, t, route, router, cookieClaimManager, currentClaims, isCustomSettingsVisible, hasAnalyticsAllowedInConfig, hasFirebaseAllowed, firebaseConfiguration, openPolicy, acceptCookies, rejectCookies, openCustomSettings, closeCustomSettingsModal, enablePlugin, CustomSettingsModal };
    }
});
